import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import LanguageButton from '../LanguageButton/LanguageButton';
import './Nav.scss';
import { RegistrationService } from '../../registration.service';

const Nav = ({ showLanguageButton, showFastpathLinks }) => {
  const registrationService = new RegistrationService();
  let search = registrationService.getUrlSearchToObj();

  const {
    home,
    login,
    how_it_works,
    faq,
    contact_us,
    member_login,
  } = JSON.parse(HEADER_MENU_URLS);

  const locale = ['es', 'en'].includes(search.locale) ? search.locale : null;

  return (
    <nav className="Nav">
      <div className="container">
        <ul className="Nav__List">
          <li>
            <NavLink locale={locale} href={home} messageId="home"/>
          </li>
          {showFastpathLinks ? (
            <li>
              <NavLink locale={locale} href={login} messageId="signIn"/>
            </li>
          ) : (
            <Fragment>
              <li>
                <NavLink locale={locale} href={how_it_works || faq} messageId="FAQs"/>
              </li>
              <li className="active">
                <a
                  className="Nav__Link"
                  href="#"
                  onClick={e => e.preventDefault()}
                >
                  <FormattedMessage id="register" />
                </a>
              </li>
              <li>
                <NavLink locale={locale} href={contact_us} messageId="contactUs"/>
              </li>
              <li>
                <NavLink locale={locale} href={member_login} messageId="signIn"/>
              </li>
              <li>
                {showLanguageButton && (
                  <LanguageButton className="Nav__LanguageButton" />
                )}
              </li>
            </Fragment>
          )}
        </ul>
      </div>
    </nav>
  );
};

const NavLink = ({ locale, href, messageId }) => {
  return (
    <a
      className="Nav__Link"
      href={`${href}${locale ? `?locale=${encodeURIComponent(locale)}` : ''}`}
    >
      <FormattedMessage id={messageId} />
    </a>
  );

}

export default Nav;



// WEBPACK FOOTER //
// ./registration-react/components/Nav/Nav.js